import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Auth } from '@synegen/utility';

export const unauthGuard: CanActivateFn = (route, state) => {
  const auth: Auth = inject(Auth);
  const router = inject(Router);
  if (auth.isAuthenticated()) {
    return router.createUrlTree(['/']);
  }

  return true;
};
